import React from "react";
import styled from "styled-components";

/** Conteneur principal du footer */
const FooterContainer = styled.footer`
  background-color: #15b5b0; /* Bleu profond */
  color: #ffffff;
  padding: 10px 0;
  margin-top: auto;
  text-align: center;
`;

/** Conteneur centré pour les informations */
const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    gap: 50px;
  }
`;

/** Style pour les liens */
const FooterLink = styled.a`
  color: #f7d07c;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s;

  &:hover {
    color: #eebba5;
  }
`;

/** Ligne de séparation */
const Divider = styled.hr`
  width: 60%;
  border: 0.5px solid #eebba5;
  margin: 10px auto;
`;

/** Texte standard */
const Text = styled.p`
  margin: 0;
`;

/** Conteneur pour le logo */
export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

/** Style pour le logo */
export const Logo = styled.img`
  height: 150px;
  border-radius: 25%;
`;

export const HoraireContainer = styled.div`
  width: 25%;
`;

/** Composant Footer */
const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <InfoContainer>
        <div>
          <Text>
            <strong>Méli Mel’O</strong>
          </Text>
          <Text>100 rue de la mairie, 59630 Looberghe</Text>
          <Text>
            Téléphone :{" "}
            <FooterLink href="tel:+33699090493">06.99.09.04.93</FooterLink>
          </Text>
          <Text>
            Email :{" "}
            <FooterLink href="mailto:melimelo59630@gmail.com">
              melimelo59630@gmail.com
            </FooterLink>
          </Text>
        </div>

        <LogoContainer>
          <Logo src="/logo.png" alt="Logo Méli Mel'O" />
        </LogoContainer>
        <div>
          <Text>
            <strong>Horaire d'ouverture : </strong>
          </Text>
          <Text>Du lundi au vendredi de 7h30 à 18h30</Text>
          <Text>
            <strong>Fermeture annuelle: </strong>
          </Text>
          <Text>1 semaine aux vacances d'avril,</Text>
          <Text>3 semaines aux vacances d'été et</Text>
          <Text>1 semaine aux vacances d'hiver</Text>
        </div>
      </InfoContainer>

      <Divider />

      <Text>
        © {new Date().getFullYear()} Méli Mel’O. Tous droits réservés.
      </Text>
    </FooterContainer>
  );
};

export default Footer;
